
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.md?watch=parent';
    export const demoIndex = {
  ids: ["heatmap-demo-0","heatmap-demo-1"],
  getter: () => import(/* webpackChunkName: "meta__HeatMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.md?type=demo')
};